'use client';
import { type Brand } from '@curology/ui-components-web/brand';
import { Typography } from '@curology/ui-components-web/react';
import React, { useEffect, useState } from 'react';

import { CheckoutFooter } from '@/components/flow/expressCurologySignUpSkin/components/checkoutFooter';
import { PriceSummaryAccordion } from '@/components/flow/expressCurologySignUpSkin/components/priceSummaryAccordion';
import { type ExpressCurologySignUpSkinPdpSourceConfigType } from '@/components/flow/expressCurologySignUpSkin/types';
import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { useRouter } from '@/hooks/useRouter';
import { getVisit } from '@/services/visitsService/client';
import { type AnalyticsPatientResource } from '@/types/metrics/analyticsPatient';

import { ShippingAddressForm } from './components/shippingAddressForm';

export const ClientContainer = ({
  brand,
  bundleConfig,
  giftWithPurchaseImageUrl,
  patient,
  treatmentCategory,
  uuid,
}: {
  brand: Brand;
  bundleConfig: ExpressCurologySignUpSkinPdpSourceConfigType;
  giftWithPurchaseImageUrl?: string;
  patient: AnalyticsPatientResource;
  treatmentCategory: TreatmentCategory;
  uuid: string;
}) => {
  const [selectedAddOnProductItemIds, setSelectedAddOnProductItemIds] =
    useState<number[]>([]);

  const router = useRouter();

  useEffect(() => {
    const getCurrentVisit = async () => {
      const visit = await getVisit({ uuid });

      if (visit?.sessionBag?.selectedAddOnProductItemIds) {
        setSelectedAddOnProductItemIds(
          visit.sessionBag.selectedAddOnProductItemIds,
        );
      }

      if (visit?.sessionBag?.hasActivatedTrial) {
        router.refresh();
      }
    };

    getCurrentVisit();
  }, [uuid, router]);

  return (
    <React.Fragment>
      <PriceSummaryAccordion
        bundleConfig={bundleConfig}
        giftWithPurchaseImageUrl={giftWithPurchaseImageUrl}
        selectedAddOnProductItemIds={selectedAddOnProductItemIds}
      />
      <div className="cur-bg-surface-neutral cur-p-4">
        <Typography className="cur-mb-4" weight="bold">
          Create account
        </Typography>
        <Typography>{patient.email}</Typography>
      </div>
      <div className="cur-bg-surface-neutral cur-p-4">
        <Typography className="cur-mb-4" weight="bold">
          Payment method
        </Typography>
        <Typography>Card ending in {patient.cardLastFour}</Typography>
      </div>
      <div className="cur-bg-surface-neutral cur-p-4">
        <Typography className="cur-mb-4" weight="bold">
          Shipping address
        </Typography>
        <ShippingAddressForm
          brand={brand}
          bundleConfig={bundleConfig}
          patient={patient}
          selectedAddOnProductItemIds={selectedAddOnProductItemIds}
          treatmentCategory={treatmentCategory}
          uuid={uuid}
        />
      </div>
      <CheckoutFooter
        bundleConfig={bundleConfig}
        selectedAddOnProductItemIds={selectedAddOnProductItemIds}
      />
    </React.Fragment>
  );
};
